var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6049 21.9566L22.4566 12.1049C22.5145 12.047 22.5145 11.953 22.4566 11.8951L12.6049 2.04344C12.547 1.98552 12.453 1.98552 12.3951 2.04344L2.54344 11.8951C2.48552 11.953 2.48552 12.047 2.54344 12.1049L12.3951 21.9566C12.453 22.0145 12.547 22.0145 12.6049 21.9566ZM23.8708 13.5191C24.7097 12.6801 24.7097 11.3199 23.8708 10.4809L14.0191 0.629225C13.1801 -0.209742 11.8199 -0.209742 10.9809 0.629225L1.12923 10.4809C0.290258 11.3199 0.290258 12.6801 1.12922 13.5191L10.9809 23.3708C11.8199 24.2097 13.1801 24.2097 14.0191 23.3708L23.8708 13.5191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6634 13.9323L18.4323 8.16336C18.5226 8.07314 18.5226 7.92686 18.4323 7.83664L12.6634 2.06767C12.5731 1.97744 12.4269 1.97744 12.3366 2.06767L6.56767 7.83664C6.47744 7.92686 6.47744 8.07314 6.56767 8.16336L12.3366 13.9323C12.4269 14.0226 12.5731 14.0226 12.6634 13.9323ZM19.8465 9.57758C20.7178 8.7063 20.7178 7.2937 19.8465 6.42242L14.0776 0.653454C13.2063 -0.217817 11.7937 -0.217818 10.9224 0.653453L5.15345 6.42242C4.28218 7.29369 4.28218 8.7063 5.15345 9.57757L10.9224 15.3465C11.7937 16.2178 13.2063 16.2178 14.0776 15.3465L19.8465 9.57758Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySection);
export default __webpack_public_path__ + "static/media/empty-section.c035cf75.svg";
export { ForwardRef as ReactComponent };